module.exports = __webpack_public_path__ + "static/media/vybecabs.e279042d.svg";